var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeLt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81802 0.696751L6.87868 1.75741L3.3785 5.25759H16.7428L16.7428 6.74251H3.3785L6.87868 10.2427L5.81802 11.3034L0.514719 6.00005L5.81802 0.696751Z",
    fill: "#111517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLt);
export default __webpack_public_path__ + "static/media/shape-lt.77558f7075dda44dbfe1b298e68a0b81.svg";
export { ForwardRef as ReactComponent };